import React, { useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material';
import moment from 'moment';

import { Button, CustomIconButton } from '../../../../../common/button';
import { MISC_DATE_ISO_FORMAT, MISC_DATE_POLISH_DATE_ONLY_FORMAT } from '../../../../../../core/constants';

const DetailsDialog = ({ product }) => {
    const [open, setOpen] = useState(false);

    const onClose = () => setOpen(false);

    return (
        <>
            <CustomIconButton
                title={ 'Szczegóły' }
                onClick={ () => setOpen(true) }
                icon={ <SearchIcon/> }
            />

            <Dialog
                open={ open }
                onClose={ onClose }
                fullWidth
                maxWidth="lg"
                PaperProps={ {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '8px',
                        maxHeight: '80vh'
                    },
                } }
            >
                <DialogTitle sx={ { fontWeight: 600, pb: 1 } }>
                    { product?.name || product?.productName }
                </DialogTitle>

                <DialogContent sx={ { flex: 1, overflowY: 'auto', py: 0 } }>
                    <Box sx={ { mt: 2 } }>
                        <TableContainer>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                                        { product?.expirationDate && (
                                            <TableCell align="center">Data przydatności</TableCell>
                                        ) }
                                        <TableCell align="center">Kaucja</TableCell>
                                        <TableCell align="center">Cena podstawowa [brutto]</TableCell>
                                        <TableCell align="center">Promocja</TableCell>
                                        <TableCell align="center">Rabat (promocja)</TableCell>
                                        <TableCell align="center">Krótki termin</TableCell>
                                        <TableCell align="center">Rabat (krótki termin)</TableCell>
                                        { product?.promotionGrossPrice && (
                                            <TableCell align="center">Cena promocyjna [brutto]</TableCell>
                                        ) }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow hover>
                                        { product?.expirationDate && (
                                            <TableCell align="center">
                                                { moment(product?.expirationDate, MISC_DATE_ISO_FORMAT)
                                                    .format(MISC_DATE_POLISH_DATE_ONLY_FORMAT) }
                                            </TableCell>
                                        ) }
                                        <TableCell align="center">
                                            { product?.depositAmount?.toFixed(2) }
                                        </TableCell>
                                        <TableCell align="center">
                                            { product?.basicPrice?.toFixed(2) }
                                        </TableCell>
                                        <TableCell align="center">
                                            { product?.productPromotionId
                                                ? <CheckIcon color="success" fontSize="small"/>
                                                : <ClearIcon color="error" fontSize="small"/> }
                                        </TableCell>
                                        <TableCell align="center">
                                            { product?.productDiscountAmount?.toFixed(2) }
                                        </TableCell>
                                        <TableCell align="center">
                                            { product?.expirationPromotionId
                                                ? <CheckIcon color="success" fontSize="small"/>
                                                : <ClearIcon color="error" fontSize="small"/> }
                                        </TableCell>
                                        <TableCell align="center">
                                            { product?.expirationDiscountAmount?.toFixed(2) }
                                        </TableCell>
                                        { product?.promotionGrossPrice && (
                                            <TableCell align="center" sx={ { fontWeight: 600 } }>
                                                { product?.promotionGrossPrice?.toFixed(2) }
                                            </TableCell>
                                        ) }
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </DialogContent>

                <DialogActions sx={ { borderTop: theme => `1px solid ${ theme.palette.divider }`, p: 2 } }>
                    <Button onClick={ onClose } variant="outlined">
                        Zamknij
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DetailsDialog;